exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".box_simple_iiii{display:inline-block;float:left;position:relative;height:113px;overflow:hidden;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/companies/companies.css
// module id = 232
// module chunks = 0